import { Box, Button, Dialog, DialogActions, DialogContent, FormHelperText } from "@mui/material";
import Grid from '@mui/material/Grid';
import React, { useState } from "react";
import { useRecoilValue } from "recoil";
import { toast } from "react-toastify";
import { NoteService } from "../../../../Component/Api/Note/NoteService";
import { UserAtom } from "../../../../State/user.Atom";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Note } from "../../../../Component/Model/Dto/Note";
import { feedbackSchema } from "./FeedbackValidation";
import { MDBox } from "../../../../Component/Common/Components/MDBox";
import { MDTypography } from "../../../../Component/Common/Components/MDTypography";
import { Quill } from "../../../../Component/Common/Components/Quill/Quill";
import { CustomDialogTitle } from "../../Custom/CustomDialogTitle";


interface IProps {
    noteId: string;
    userId: string;
    refreshTable: () => void;
    showFeedbackModal: boolean;
    closeFeedbackModal: () => void;

}

export const FeedbackModal = (props: IProps) => {

    const user = useRecoilValue(UserAtom);
    const [createdDate] = useState<Date>(new Date());
    const [feedbackId, setFeedbackId] = useState<number>(0);
    const noteMaxLength: number = 1000;
    const [remainingNoteCharacters, setRemainingNoteCharacters] = useState(noteMaxLength);

    const  { control, handleSubmit, formState: { errors } ,setValue} = useForm<Note.FeedbackDto>({
        mode: 'all',
        defaultValues: {
            CreatedDate: createdDate.toUTCString(),
            EditUserId: props.userId,
            UserId: props.userId,
            Username: user.username,
            NoteId: props.noteId
        },
        resolver: yupResolver(feedbackSchema)
    });

    const handleDataSubmit: SubmitHandler<Note.FeedbackDto> =  async(feedbackItem: Note.FeedbackDto) => {
        try{
            if(feedbackId === 0){

                let result = await NoteService.SaveFeedback(feedbackItem);
                toast.success("Feedback item added succesfully");
                setFeedbackId(result.data);
            }
            else{
                feedbackItem.Id = feedbackId;
                await NoteService.SaveFeedback(feedbackItem);
                toast.success("Feedback item saved succesfully");
            }

            props.refreshTable();

        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>
         <Dialog open={props.showFeedbackModal} onClose={props.closeFeedbackModal} aria-labelledby="form-dialog-title" maxWidth='md' fullWidth>
                <CustomDialogTitle id="customized-dialog-title" onClose={() => props.closeFeedbackModal()}>
                    {"Create New Note Feedback Entry"}
                </CustomDialogTitle>
                <DialogContent>
                <Grid container justifyContent='center' sx={{ my: 2 }}>
                    <Grid item xs={10} lg={10}>
                        <form id="feedbackForm" onSubmit={handleSubmit(handleDataSubmit)}>
                            <MDBox>
                                <MDBox mb={1}>
                                    <Grid item xs={12}>
                                        <MDBox mb={2}>
                                            <Grid container >
                                                <Grid item xs={12} sm={4} md={4} lg={4}>
                                                    <MDTypography style={{color:'#666666', fontSize:"0.85em"}} >
                                                        User
                                                    </MDTypography>
                                                </Grid>
                                                <Grid item xs={12} sm={5} md={4} lg={4}>
                                                    <MDTypography style={{color:'#666666', fontSize:"0.85em"}} >
                                                        {user.username}
                                                    </MDTypography>
                                                </Grid>
                                            </Grid>
                                        </MDBox>
                                        <MDBox mb={2}>
                                            <Grid container >
                                                <Grid item xs={12} sm={4} md={4} lg={4}>
                                                    <MDTypography style={{color:'#666666', fontSize:"0.85em"}} >
                                                        Date
                                                    </MDTypography>
                                                </Grid>
                                                <Grid item xs={12} sm={5} md={4} lg={4}>
                                                    <MDTypography style={{color:'#666666', fontSize:"0.85em"}} >
                                                        {createdDate.toLocaleString().replace(',','')}
                                                    </MDTypography>
                                                </Grid>
                                            </Grid>
                                        </MDBox>      
                                        <MDBox mb={2} className="leftAlign">
                                            <MDTypography
                                                variant='button'
                                                fontWeight='regular'
                                                style={{color:!!errors.Feedback? 'error': '#666666', fontSize:"0.85em"}}
                                                >
                                                Feedback* (Max 1000 characters)
                                            </MDTypography>
                                            <Controller
                                                control={control}
                                                name="Feedback"
                                                render={({ field: { onChange, value } }) => (
                                                    <Quill
                                                        initialContent={value}
                                                        maxLength={noteMaxLength}
                                                        handleChange={(newValue: string) => {
                                                            onChange(newValue);
                                                            setValue('Feedback', newValue);
                                                        }}
                                                    setRemainingCharacters={setRemainingNoteCharacters}
                                                />
                                        )}
                                    />
                                        <MDTypography
                                            variant="button"
                                            fontWeight="regular"
                                            style={{  color:
                                                remainingNoteCharacters < 0
                                               ? "#FF0000" 
                                               : "#666666", 
                                                fontSize: "0.85em"
                                            }}
                                        >
                                            {remainingNoteCharacters} characters remaining
                                        </MDTypography>
                                            {(!!errors.Feedback) && <FormHelperText error>{errors.Feedback?.message}</FormHelperText>}
                                        </MDBox>                
                                    </Grid>
                                </MDBox>
                            </MDBox>
                        </form>
                    </Grid>
                </Grid>
                </DialogContent>
                <DialogActions>
                    <MDBox mb={3}>
                        <Button  variant='contained' color="primary" type='submit' form="feedbackForm" >
                            Save 
                        </Button>
                    </MDBox>
                </DialogActions>
            </Dialog>
    </>);

}
